export function requestUserPasswordResetToken(apiUrl, user, email) {

  return fetch(`${apiUrl}/auth/password-reset/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ user, email }),
  });
}

export function updateUserPassword(apiUrl, userId, newPassword, token) {

  return fetch(`${apiUrl}/auth/password-reset/${userId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      token,
      newPassword,
    }),
  });
}